<script>
import { ref, onMounted } from 'vue'
import counterUp from 'counterup2'
export default {
  name: 'renderless-ticker',
  props: {
    duration: {
      type: Number,
      default: 1000
    },
    delay: {
      type: Number,
      default: 0
    }
  },
  setup (props, { slots }) {
    const counter = ref(null)
    const handleObserver = (entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          counterUp(counter.value, props)
          observer.unobserve(counter.value)
        }
      })
    }
    const observer = new IntersectionObserver(handleObserver)
    onMounted(() => observer.observe(counter.value))
    return () => slots.default({
      counter
    })
  }
}
</script>
